/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';

import Colors from 'constants/Colors';
import {Breakpoints} from "../../constants/Breakpoints";

const propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array
    ]),
    error: PropTypes.string,
    isFocused: PropTypes.bool
  }),
  isRequired: PropTypes.bool,
  inline: PropTypes.bool,
  textColor: PropTypes.bool,
};

const defaultProps = {
  meta: undefined,
  isRequired: false,
  inline: false
};

const LabelText = styled.label`
  font-size: ${({ fontSize }) => fontSize || 13}px;
    word-break: break-word;
`;

const Container = styled.div`
  display: inline-flex;
  width: 100%;
  vertical-align: middle; 
  margin: 0;
  
  color: ${Colors.GRAY[6]};
  // overflow: hidden;
  // white-space: nowrap;
  text-overflow: ellipsis;
  ${({ wordBreak }) => wordBreak ? 'word-break: break-all;' : ''};
  ${({ wordWrap }) => wordWrap ? 'overflow-wrap: break-word;' : ''}
  


  ${({ textColor }) =>
    textColor
      ? css`
          ${textColor == Colors.PURPLE ? 'font-weigth:bold !important;' : ''}
          color:${textColor};
          `
      : `color: ${Colors.GRAY[6]};`
  }

  ${({ setMinHeight }) =>
    setMinHeight &&
    css`
      min-height: 25px;
    `}

  & ${LabelText} {
    ${({ inverse }) =>
    inverse &&
    `
      color: ${Colors.WHITE};
    `}

    ${({ isRequired }) =>
    isRequired
      ? css`
            color: ${Colors.SECONDARY_MEDIUM};
          `
      : ''}
  
    ${({ meta }) =>
    meta && meta.touched && meta.error
      ? css`
            color: ${Colors.DANGER};
          `
      : ''}

    ${({ meta }) =>
    meta && meta.isFocused && !meta.error
      ? css`
            color: ${Colors.PRIMARY1};

            transition: color 0.15s ease;
          `
      : ''}

    font-weight: 700;
    transition: color 0.15s ease;
  }

  ${({ inline }) =>
    inline &&
    css`
      min-width: 40px;
      margin: 0 8px 0 0;
      overflow: unset;
      white-space: normal;
      line-height: 16px;
      display: flex;
      align-items: center;
      text-align: right;
    `}
    
  @media screen and (min-width: ${Breakpoints.sm}) {
    width: unset;
  }
  @media screen and (min-width: ${Breakpoints.md}) {
    display: block;
  }
`;

const Label = ({
  children,
  weight,
  setMinHeight,
  isRequired,
  hideLabelAsterisk,
  inline,
  inverse,
  fontSize,
  ...props
}) => (
    <Container
      setMinHeight={setMinHeight}
      isRequired={isRequired}
      inline={inline}
      inverse={inverse}
      {...props}
    >
      <LabelText weight={weight} fontSize={fontSize}>
        {children && isRequired && !hideLabelAsterisk ? '* ' : ''}
        {children}
      </LabelText>
    </Container>
  );


Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
